import { render, staticRenderFns } from "./ShareSmallRoutinePages.vue?vue&type=template&id=58c58b42&scoped=true&"
import script from "./ShareSmallRoutinePages.vue?vue&type=script&lang=js&"
export * from "./ShareSmallRoutinePages.vue?vue&type=script&lang=js&"
import style0 from "./ShareSmallRoutinePages.vue?vue&type=style&index=0&id=58c58b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c58b42",
  null
  
)

export default component.exports